import React, {
    useContext,
    useEffect,
    useState,
    useMemo,
    useCallback,
    useRef
} from 'react';
import {observer} from "mobx-react-lite";
import NoodlesRain from '../../components/NoodlesRain/NoodlesRain';
import {Context} from "../../index";
import {
    fetchProducts,
    getDataForBreadcrumbs,
    getCategory,
    mindboxViewCategory,
    fetchFilterContext,
    countFilterdProducts
} from "../../http/catalogApi";
import './catalogstyle.css';
import BreadcrmbsAndFilterLine from "../../components/catalog/BrcrmbAndFilter/BreadcrmbsAndFilterLine";
import {Link, useParams} from "react-router-dom";
import OneProductCart from "./OneProductCart";
import Spiner from "../administrator/spiner/Spiner";
import Pagination from "../../components/Paginstion";
import BreadcrumbsCatalog from "../../components/catalog/BrcrmbAndFilter/breadcrumbsCatalog/BreadcrumbsCatalog";
import {pushGoogleAnalyticProductAction} from "../../utils/googleAnalytic";
import {useLocation, useNavigate} from "react-router";
import NotFound from '../content/notFound/NotFound';
import { FilterContext } from "../../services/FilterContext";
import { getParentCategories } from '../../http/catalogApi';
import { getAlterTitleAndDesc, getAlterTitleAndDescHitCategori } from '../../utils/seo.helper';
import mindBox from '../../analytics/mindBox';
import { readCatalogCollectionResponse } from '../../utils/publicCatalogResponse';

const emptyFilters = () => ({colors: [], sizes: [], trends: [], price_current: []});
const snapshotFilters = value => ({
    ...value,
    colors: value.colors.map(item => ({...item})),
    sizes: value.sizes.map(item => ({...item})),
    trends: value.trends.map(item => ({...item})),
    price_current: [...value.price_current]
});

const parrentTitles = {
    sale: 'Sale',
    UNISEX: 'UNISEX',
    velvetin: 'YW X VELVETIN',
    'new-collection': 'Новинки',
    coming_soon: 'Скоро в наличии',
    bestseller: 'Бестселлеры',
}

const Catalog = observer(() => {

    const {settings} = useContext(Context);
    const [filters, setFilters] = useState({
        colors: [],
        sizes: [],
        trends: [],
        price_current: []
    })
    const googleAnalyticProducts = {}
    const [notFound, setNotFound] = useState(false);
    const shippedToAnalyticProductIds = []
    const [applyFilter, setApplyFilter] = useState(0);
    const [disabledFilterBtn, setDisabledFilterBtn] = useState(false);
    const [appliedFilters, setaAppliedFilters] = useState({
        colors: [],
        sizes: [],
        trends: [],
        price_current: []
    });
    const [actualCat, setActualCat] = useState({});
    const [catalogFakeCategory, setCatalogFakeCategory] = useState([]);
    const [count, setCount] = useState(null)
    const [countFiltered, setCountFiltered] = useState(null)
    const [rowsError, setRowsError] = useState(false);
    const [facetsError, setFacetsError] = useState(false);
    const [countError, setCountError] = useState(false);
    const [rowsRetry, setRowsRetry] = useState(0);
    const [facetsRetry, setFacetsRetry] = useState(0);
    const [countRetry, setCountRetry] = useState(0);
    const [rowsStateKey, setRowsStateKey] = useState('');
    const [facetsScope, setFacetsScope] = useState('');
    const [facetsPending, setFacetsPending] = useState(true);
    const [metadataScope, setMetadataScope] = useState('');
    const [productsArray, setProductsArray] = useState([]);
    const [spiner, setSpiner] = useState(true);
    const [category, setCategory] = useState(false)
    const [thirdCategory, setThirdCategory] = useState(false)
    const [fourthCategory, setFourthCategory] = useState(false)
    const [parrentCategory, setParrentCategory] = useState(null)
    const [deviceUUID, setDeviceUUID] = useState('')
    const [userAgent, setUserAgent] = useState('')
    const [showFilters, setShowFilters] = useState(true)
    const [pathName, setPathName] = useState('');
    const [paramsForBreadcrumbs, setParamsForBreadcrumbs] = useState();
    const [catalogModelView, setCatalogModelView] = useState('standart');
    const [transitionButton, setTransitionButton] = useState(false)
    const [seoText, setSeoText] = useState(false)

    const params = useParams()
    const navigate = useNavigate();

    const location = useLocation();
    const parrent = params.parrentCategory;
    const child = params.childCategory;
    const third = params.thirdCategory;
    const fourth = params.fourthCategory;
    const scopeKey = JSON.stringify([parrent, child, third, fourth]);
    const currentCategory = metadataScope === scopeKey ? category : false;
    const currentThird = metadataScope === scopeKey ? thirdCategory : false;
    const currentFourth = metadataScope === scopeKey ? fourthCategory : false;
    const currentParent = metadataScope === scopeKey ? parrentCategory : null;
    const currentActualCat = metadataScope === scopeKey ? actualCat : {};
    const currentBreadcrumbs = metadataScope === scopeKey ? paramsForBreadcrumbs : undefined;
    const facetsReady = facetsScope === scopeKey && !facetsPending && !facetsError;

    const limit = 32;

    let totalProductsCount = 0;
    let analyticProductsList = []

    const fetchCatalogFakeCategory = () => {
		getParentCategories().then((data) => {
            if(data.success){
                setCatalogFakeCategory(data.data);
            }
		});
	};

	useEffect(() => {
		fetchCatalogFakeCategory();
	}, []);

    const pushGoogleAnalyticViewItemList = async () => {
        if(!analyticProductsList.length)
            return false
        pushGoogleAnalyticProductAction('view_item_list', analyticProductsList)
        analyticProductsList = []
    }

    const productsObserver = new IntersectionObserver((recordsList ) => {
        recordsList.forEach((record) => {
            if(record.isIntersecting) {
                const {id} = record.target.dataset
                if(!id || shippedToAnalyticProductIds.includes(id))
                    return
                analyticProductsList.push(googleAnalyticProducts[id])
                shippedToAnalyticProductIds.push(id)

                if(analyticProductsList.length >= 15 || shippedToAnalyticProductIds.length >= totalProductsCount)
                    pushGoogleAnalyticViewItemList()
            }
        })
    })

    useEffect(() => {
        if(location) {
            let tmp = location.search
            setPathName(tmp) ;
        }
    }, [location])

    const queryParams = new URLSearchParams(location.search)
    let page = +queryParams.get('page')
    let sort = queryParams.get('sort')

    if (!sort) {
        sort = 'default'
    }

    if (page === 0) {
        page = 1
    }

    if (location.search) {
        const params = new URLSearchParams(location.search);
        page = params.get("page");
        if (!page || page <= 0) {
            page = 1
        }
    } else if (!page || page <= 0) {
        page = 1
    }
    let pageSuffix = '';
    if (page && pathName && page > 1) pageSuffix = ' - страница №' + page;

    useEffect(() => {
        setDeviceUUID(document.cookie.replace(/(?:(?:^|.*;\s*)mindboxDeviceUUID\s*\=\s*([^;]*).*$)|^.*$/, "$1"))
        setUserAgent(window.navigator.userAgent)
    }, [])

    useEffect(() => {
        if (metadataScope === scopeKey && actualCat.id) {
            mindBox.personalization.viewCategory({id: actualCat.id});
            mindboxViewCategory(deviceUUID, userAgent, actualCat)

            if (window.turboTarget && window.turboTarget.sendRTGMessage) {
                window.turboTargetPixelRTGVisitCategory(actualCat.id);
            } else {
                document.addEventListener("generalPixelInited", () => {
                    window.turboTargetPixelRTGVisitCategory(actualCat.id)
                })
            }
        }
    }, [actualCat, metadataScope, scopeKey])

    if(parrent == 'sale' && sort == 'default'){
        sort= 'price_up'
    }
    const rowsKey = JSON.stringify([scopeKey, page, sort, applyFilter, rowsRetry]);
    const currentProducts = rowsStateKey === rowsKey ? productsArray : [];

    useEffect(() => {
        setSeoText(false)
        if (
            (parrent === 'sale'
            || parrent === 'bestseller'
            || parrent === 'coming_soon'
            || parrent === 'new-collection')
            && currentCategory
        ) {
            setSeoText('')
            return
        }
        if(page !== 1){
            setSeoText('')
        } else if (currentFourth){
            if (currentFourth.seo_text) {
                setSeoText(currentFourth.seo_text);
            }
        } else if(currentThird){
            if(currentThird.seo_text){
                setSeoText(currentThird.seo_text)
            }
        } else if(currentCategory){
            if(currentCategory.seo_text){
                setSeoText(currentCategory.seo_text)
            }
        } else if(currentParent){
            if(currentParent.seo_text){
                setSeoText(currentParent.seo_text)
            }
        }
    }, [currentCategory, currentParent, currentThird, currentFourth, parrent, page, scopeKey])

    const googleAnalyticCategory = useMemo(() => {
        if(!currentCategory && !parrent)
            return {
                item_list_id: 0,
                item_list_name: 'Каталог',
            }

        if(!currentCategory && parrent)
            return {
                item_list_id: parrent,
                item_list_name: parrentTitles[parrent],
            }

        return {
            item_list_id: `${parrent}-${currentCategory.id}`,
            item_list_name: currentCategory.name,
        }
    }, [currentCategory, parrent])

    const observeProduct = useCallback((product, ref, selectSize) => {
        totalProductsCount++
        const customProps = {
            index: totalProductsCount,
            ...googleAnalyticCategory,
        }
        if (product.child_product_size) {
            let findSize = product.child_product_size.find(element => element.size_name === selectSize);
            if (findSize) {
                let offerId = String(product.id)+String(product.color.id)+findSize.id;
                googleAnalyticProducts[offerId] = {...product, currentSize: selectSize, customProps}
                productsObserver.observe(ref)
            }
        }
    }, [googleAnalyticCategory])

    useEffect(() => {
        pushGoogleAnalyticViewItemList()
        return pushGoogleAnalyticViewItemList
    }, [category, parrent])

    const setFilterParam = (value) => {
        navigate({pathname: '.', search: `?${newQueryString('sort', value)}`});
        sort = value
    }

    const newQueryString = (key, value) => {
        let searchParams = new URLSearchParams(location.search);
        if (key === 'page') {
            if (value < 2) {
                searchParams.delete(key);
            } else {
                searchParams.set(key, value);
            }
        } else {
            if (value == 'default') {
                searchParams.delete(key)
            } else {
                searchParams.set(key, value);
            }
        }
        return searchParams.toString()
    };

    const handleScroll = () => {
        if(window.scrollY)
            settings.setScrollStatusCatalog(window.scrollY);
    };



    const allPages = Math.ceil(count / limit)

    useEffect(() => {
        if (allPages > 1) {
            setTransitionButton(true)
        } else {
            setTransitionButton(false)
        }

    }, [count])


    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    const prevCats = usePrevious(scopeKey)

    const linkNewPage = (count, limit, page) => {
        if (!count || !limit) {
            setTransitionButton (false)
        }

        if(!page || page <= 0) {
            setTransitionButton (true)
        }

        if(count <= limit) {
            setTransitionButton (false)
        }
    }

    useEffect(() => {
        let active = true;
        setFacetsScope(scopeKey);
        setFacetsPending(true);
        setFacetsError(false);
        setShowFilters(false);
        setFilters(emptyFilters());
        const fail = () => {if (active) setFacetsError(true);};
        fetchFilterContext(parrent, child, third, fourth, catalogFakeCategory).then(response => {
            if (!active) return;
            const result = readCatalogCollectionResponse('facets', response);
            if (!result.ok) {fail(); return;}
            if (result.data.hide === true) return;
            setShowFilters(true);
            setFilters({...result.data, price_current: [result.data.price_min, result.data.price_max],
                filter_price: [result.data.price_min, result.data.price_max]});
        }).catch(fail).finally(() => {if (active) setFacetsPending(false);});
        return () => {active = false;};
    }, [scopeKey, facetsRetry])

    useEffect(() => {
        let active = true;
        let needFilter = true;
        window.scrollTo(0, 0);
        setRowsStateKey(rowsKey);
        setProductsArray([]);
        setCount(null);
        setSpiner(true);
        setRowsError(false);
        setNotFound(false);
        if (metadataScope !== scopeKey) {
            setCategory(false); setThirdCategory(false); setFourthCategory(false);
            setParrentCategory(null); setActualCat({}); setSeoText(false);
            setParamsForBreadcrumbs(undefined); setMetadataScope(scopeKey);
            setaAppliedFilters(emptyFilters());
        }
        const cat = fourth || third || child;
        if (parrent) {
            getCategory(parrent).then(response => {
                if (!active) return;
                if (response.success) {
                    setParrentCategory(response.data);
                    if (!cat) {
                        setActualCat(response.data);
                    }
                } else {
                    setParrentCategory(null)
                }
            }).catch(() => {if (active) setParrentCategory(null);})
        }
        if (cat) {
            getCategory(cat).then(response => {
                if (!active || !response.success) return;
                setCategory(response.data);
                if (third && !fourth) setThirdCategory(response.data);
                if (fourth) setFourthCategory(response.data);
                setActualCat(response.data);
            }).catch(() => {});
        }

        if (prevCats && prevCats !== scopeKey) {
            needFilter = false;
            if (applyFilter) {
                setApplyFilter(0);
            }
        } else if (!applyFilter) {
            needFilter = false;
        }

        const fail = () => {if (active) setRowsError(true);};
        fetchProducts(parrent, child, third, fourth, catalogFakeCategory, limit, page, sort,
            needFilter ? snapshotFilters(appliedFilters) : null, true).then(response => {
                if (!active) return;
                const result = readCatalogCollectionResponse('rows', response);
                if (!result.ok) {
                    if (result.status === 404) setNotFound(true);
                    else fail();
                    return;
                }
                setProductsArray(result.data.rows);
                setCount(result.data.count);
            }).catch(fail).finally(() => {if (active) setSpiner(false);});

        getDataForBreadcrumbs(parrent, child, third, fourth, catalogFakeCategory).then(response => {
            if (active) setParamsForBreadcrumbs(response)
        }).catch(() => {if (active) setParamsForBreadcrumbs(undefined);});
        return () => {active = false;};
    }, [scopeKey, sort, page, applyFilter, rowsRetry])

    useEffect(() => {
        let active = true;
        setDisabledFilterBtn(true);
        setCountFiltered(null);
        setCountError(false);
        if (!facetsReady) return () => {active = false;};
        const fail = () => {if (active) setCountError('Не удалось посчитать товары. Попробуйте ещё раз.');};
        countFilterdProducts(parrent, child, third, fourth, catalogFakeCategory, snapshotFilters(filters)).then(response => {
            if (!active) return;
            const result = readCatalogCollectionResponse('count', response);
            if (!result.ok) {fail(); return;}
            setCountFiltered(result.data.count);
        }).catch(fail).finally(() => {if (active) setDisabledFilterBtn(false);});
        return () => {active = false;};
    }, [scopeKey, facetsReady, filters.colors, filters.sizes, filters.trends, filters.price_current, countRetry])

    const setFilteredProducts = () => {
        setaAppliedFilters({
            colors: filters.colors.filter(item => item.checked),
            sizes: filters.sizes.filter(item => item.checked),
            trends: filters.trends.filter(item => item.checked),
            price_current: filters.price_current
        })
        if (page > 1) {
            setPage(1)
            setApplyFilter(applyFilter+1)
        } else {
            setApplyFilter(applyFilter+1)
        }
    }

    const setPage = (value) => {
        navigate({pathname: '.', search: `?${newQueryString('page', value)}`});
    }

    const resetFilters = () => {
        setApplyFilter(0);
    }

    if (rowsStateKey === rowsKey && notFound) {
        return (
            <NotFound/>
        )
    }

    return (
        <FilterContext.Provider value={{filters, setFilters, setFilteredProducts, countFiltered, resetFilters,
            disabledFilterBtn: disabledFilterBtn || !facetsReady || !!countError, countError,
            retryCount: () => setCountRetry(value => value + 1)}}>
        <>
            {(
                window.location.pathname.includes("catalog/collab/youwannarollton")
            ) && (
                <NoodlesRain/>
            )}
            <div  itemscope="" itemtype="https://schema.org/OfferCatalog" style={{marginTop: settings.headerHeight}} className={"catalog_section"}>
                {
                    parrent !== "bestseller" && parrent !== "new-collection" && parrent !== "coming_soon" && parrent !== "sale"  ?
                        getAlterTitleAndDescHitCategori(currentParent, parrent, currentCategory, location, pageSuffix)
                    : getAlterTitleAndDesc(parrent, currentCategory, location, pageSuffix)
                }
                 <span style={{display: "none"}} itemprop="name">Каталог YOUWANNA</span>   
                 <span  style={{display: "none"}} itemprop="description">Женская одежда в интернет-магазине YOU WANNA. Трендовые модели. Большой выбор стильных платьев, пиджаков, джемперов, юбок, брюк. Доставка по России. Контактная информация: +7 (925) 139-60-25</span>
                  <img itemprop="image" style={{display: "none"}}  src="/files/images/you-wanna-seo.jpg"/>
                <div className={"filter_and_catalog"}>
                    {
                        currentProducts[0] ?
                            <div className={"breadcrmbs_catalog"}>
                                <BreadcrumbsCatalog
                                    breadcrumbsParams={currentBreadcrumbs}
                                />
                            </div>
                            : ''
                    }
                    {
                        currentActualCat.banner ?
                            <div className={'banner_container'}>
                                <img  className={'banner_img'} src={
                                    process.env.REACT_APP_API_URL+"uploads/images/categories/" + currentActualCat.banner}
                                        alt={(currentActualCat.name ? currentActualCat.name : '')}
                                />
                            </div>
                        : ''
                    }
                    {
                        currentProducts[0] ?
                            <BreadcrmbsAndFilterLine
                                setCatalogModelView={setCatalogModelView}
                                catalogModelView={catalogModelView}
                                currentStateCatalogModelView={catalogModelView}
                                filterParam={sort}
                                setFilterParam={e => setFilterParam(e)}
                                thirdCategory={currentThird}
                                fourthCategory={currentFourth}
                                category={currentCategory}
                                parrentCategory={currentParent}
                                parrent={parrent}
                                showFilters={facetsReady && showFilters}
                            />
                        : ''
                    }
                    {
                        rowsStateKey !== rowsKey || spiner ?
                            <div className={"products_wrapper " + catalogModelView}>
                                <Spiner/>
                            </div>
                        : rowsError ? <div role="alert">Не удалось загрузить товары. Попробуйте ещё раз.
                            <button type="button" onClick={() => setRowsRetry(value => value + 1)}>Повторить загрузку товаров</button>
                          </div> :
                            <div itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem" className={"products_wrapper " + catalogModelView}>
                                {
                                    currentProducts[0] ? currentProducts.map((item, index) => {
                                            if (index === currentProducts.length-1 && settings.scrollStatusCatalog) {
                                                window.scrollTo(0, settings.scrollStatusCatalog)
                                            }
                                            return (<OneProductCart
                                                observeProduct={observeProduct}
                                                item={item}
                                                index={index}
                                                key={item.id}
                                                parrent={parrent}
                                                googleAnalyticCategory={googleAnalyticCategory}
                                                child={child}
                                                handleScroll={e => handleScroll()}
                                            />)
                                        }
                                    ) 
                                    : <div className={"no_find_product"}>Нет товаров</div>
                                }
                            </div>
                    }
                </div>
                {facetsScope === scopeKey && facetsError && <div role="alert">Не удалось загрузить фильтры. Попробуйте ещё раз.
                    <button type="button" onClick={() => setFacetsRetry(value => value + 1)}>Повторить загрузку фильтров</button>
                </div>}
                {
                    rowsStateKey === rowsKey && !spiner && !rowsError && count !== null && transitionButton && settings.projectWidth && settings.projectWidth < 1024 ?
                        <Link
                            onClick={e => linkNewPage(count, limit, page)}
                            to={page === allPages ? `?${newQueryString('page', parseInt(page) - 1)}` : `?${newQueryString('page', parseInt(page) + 1)}`} className="give_next_products"><span>{page != allPages ? "Показать еще" : "Вернуться назад" }</span></Link>
                    : ''
                }

                {
                    rowsStateKey === rowsKey && !rowsError && parrent !== "bestseller" && <Pagination page={parseInt(page)} limit={limit} count={count}/>
                }
                {
                    metadataScope === scopeKey && seoText ?
                        <div className="seo_text" dangerouslySetInnerHTML={{__html: seoText}}/>
                            : ""
                }
            </div>
        </>
        </FilterContext.Provider>
    );
});

export default Catalog;
